/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.css'
import { Link } from 'gatsby'

const isPhotoActive = props => {
  const { isPartiallyCurrent } = props
  return isPartiallyCurrent ? { className: styles.active } : {}
}

const isDocActive = props => {
  const { isPartiallyCurrent, href } = props
  return isPartiallyCurrent || href.includes('barPlots')
    ? { className: styles.active }
    : {}
}

class Nav extends React.Component {
  render() {
    const { className, location } = this.props
    const wrapperClasses = cx(className, styles.nav)

    const modelClasses = cx(styles.first)
    const docClasses = cx()
    const photoClasses = cx(styles.last)

    return (
      <nav id="navContainer" className={wrapperClasses}>
        <ul>
          <li className={modelClasses}>
            <Link to="/" activeClassName={styles.active}>
              Model
            </Link>
          </li>
          <li className={docClasses}>
            <Link
              to="/docs"
              activeClassName={styles.active}
              disable={true}
              getProps={isDocActive}
            >
              Documents
            </Link>
          </li>
          <li className={photoClasses}>
            <Link
              to="/photos"
              activeClassName={styles.active}
              disable={true}
              getProps={isPhotoActive}
            >
              Photos
            </Link>
          </li>
        </ul>
      </nav>
    )
  }
}

Nav.propTypes = {
  className: PropTypes.string,
}

export default Nav
